import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-location-state-item',
  templateUrl: './location-state-item.component.html',
  styleUrls: ['./location-state-item.component.css']
})
export class LocationStateItemComponent implements OnInit {

  @Input() location
  constructor() { }

  ngOnInit(): void {
  }

}
